export default __webpack_public_path__ + "/assets/wizard-casa-tipologia-trilocale.jpg";